import React from 'react';
import { motion } from 'framer-motion';
import { ZapIcon } from 'lucide-react';
import { CTAButton } from '../components/CTAButton';
export function FinalCTASection() {
  return <section className="py-10 md:py-16 px-6 bg-gradient-to-b from-[#F0E0E8] to-[#E8D0D8]" data-id="element-202">
      <div className="max-w-3xl mx-auto" data-id="element-203">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center space-y-6" data-id="element-204">
          <p className="text-xl md:text-2xl font-medium text-warmBrown" data-id="element-205">
            Hay mujeres que no están solas… pero se sienten profundamente solas.
          </p>

          <p className="text-lg text-mutedBrown leading-relaxed" data-id="element-206">
            Comparten casa. Comparten historia. Comparten responsabilidades. Y
            aun así, viven con una frase clavada por dentro:
          </p>

          <blockquote className="text-2xl md:text-3xl font-heading italic text-terracotta py-4" data-id="element-207">
            “Estoy sola aunque él está aquí.”
          </blockquote>

          <div className="space-y-4 text-lg text-mutedBrown leading-relaxed text-left md:text-center" data-id="element-208">
            <p data-id="element-209">
              No quieres destruir tu familia. No quieres exagerar. No quieres
              reaccionar por impulso.
            </p>
            <p data-id="element-210">
              Pero tampoco quieres seguir desapareciendo dentro de una relación
              que ya no te sostiene como antes.
            </p>
            <p data-id="element-211">
              Por eso hoy no necesitas más ruido. No necesitas más consejos
              vacíos. No necesitas seguir aguantando sin entender.
            </p>
            <p className="text-2xl font-heading font-bold text-warmBrown py-2" data-id="element-212">
              Necesitas claridad.
            </p>
            <p data-id="element-213">
              <strong className="font-heading text-xl" data-id="element-214">
                DESCONEXIÓN EMOCIONAL
              </strong>{' '}
              es la guía para entender qué se apagó, recuperar conexión o ganar
              la claridad necesaria para decidir antes de seguir perdiéndote a
              ti misma.
            </p>
            <p className="font-medium text-terracotta text-xl pb-6" data-id="element-215">
              No sigas esperando a desaparecer por completo dentro de una
              relación que ya no te abraza emocionalmente.
            </p>
          </div>

          <CTAButton text="QUIERO ACCEDER AHORA" microcopy="Acceso inmediato · Lectura privada · Primer paso hacia tu claridad emocional" icon={<ZapIcon className="w-5 h-5" data-id="element-217" />} data-id="element-216" />
        </motion.div>
      </div>
    </section>;
}